// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Incident API
 * API to get incident information
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesCustomFields
 */
export interface TypesCustomFields {
  /**
   *
   * @type {Array<string>}
   * @memberof TypesCustomFields
   */
  cloudProviders?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesCustomFields
   */
  databaseIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesCustomFields
   */
  databaseMemories?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesCustomFields
   */
  dbmsClusterIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesCustomFields
   */
  kubernetesVersions?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesCustomFields
   */
  neo4jVersions?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesCustomFields
   */
  omniClusters?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesCustomFields
   */
  tiers?: Array<string>;
}

/**
 * Check if a given object implements the TypesCustomFields interface.
 */
export function instanceOfTypesCustomFields(
  value: object,
): value is TypesCustomFields {
  return true;
}

export function TypesCustomFieldsFromJSON(json: any): TypesCustomFields {
  return TypesCustomFieldsFromJSONTyped(json, false);
}

export function TypesCustomFieldsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesCustomFields {
  if (json == null) {
    return json;
  }
  return {
    cloudProviders:
      json['cloud_providers'] == null ? undefined : json['cloud_providers'],
    databaseIds:
      json['database_ids'] == null ? undefined : json['database_ids'],
    databaseMemories:
      json['database_memories'] == null ? undefined : json['database_memories'],
    dbmsClusterIds:
      json['dbms_cluster_ids'] == null ? undefined : json['dbms_cluster_ids'],
    kubernetesVersions:
      json['kubernetes_versions'] == null
        ? undefined
        : json['kubernetes_versions'],
    neo4jVersions:
      json['neo4j_versions'] == null ? undefined : json['neo4j_versions'],
    omniClusters:
      json['omni_clusters'] == null ? undefined : json['omni_clusters'],
    tiers: json['tiers'] == null ? undefined : json['tiers'],
  };
}

export function TypesCustomFieldsToJSON(json: any): TypesCustomFields {
  return TypesCustomFieldsToJSONTyped(json, false);
}

export function TypesCustomFieldsToJSONTyped(
  value?: TypesCustomFields | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_providers: value['cloudProviders'],
    database_ids: value['databaseIds'],
    database_memories: value['databaseMemories'],
    dbms_cluster_ids: value['dbmsClusterIds'],
    kubernetes_versions: value['kubernetesVersions'],
    neo4j_versions: value['neo4jVersions'],
    omni_clusters: value['omniClusters'],
    tiers: value['tiers'],
  };
}
